require("!!/Users/weirong/Code/hkaf/hkaf-live-git/angular-admin-portal/node_modules/script-loader/addScript.js")(require("!!/Users/weirong/Code/hkaf/hkaf-live-git/angular-admin-portal/node_modules/raw-loader/index.js!/Users/weirong/Code/hkaf/hkaf-live-git/angular-admin-portal/node_modules/select2/dist/js/select2.full.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/select2/dist/js/select2.full.js
// module id = 303
// module chunks = 2